import { render } from "./HomeFivePage.vue?vue&type=template&id=0b73e0c2&ts=true"
import script from "./HomeFivePage.vue?vue&type=script&lang=ts"
export * from "./HomeFivePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__